import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { Tooltip, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon, Add, Devices } from '@mui/icons-material';
import PAGES from 'common/pages';
import { IconButton } from 'bso-ui';
import Toolbar from 'components/Toolbar/Toolbar';
import DefaultThresholdFilter from './Form/DefaultThresholdFilter';
import DefaultThresholdCreate from './Form/DefaultThresholdCreate';

const DefaultThresholdToolbar = ({
  title = '', isFetching, refetch, backLink, data = null, userData = null
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Toolbar
      title={title}
      backLink={backLink}
      action={(
        <>
          {data && userData.is_staff ? (
            <DefaultThresholdCreate
              title="Create Default Threshold"
              button={{
                content: (
                  <>
                    <Add />
                    Create
                  </>
                ),
                color: 'primary',
                variant: 'standard',
                state: 'outlined'
              }}
              refetch={refetch}
            />
          ) : null}
          {isFetching ? (
            <div style={{
              height: 48, width: 48, display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}
            >
              <CircularProgress size={22} />
            </div>
          ) : (
            <Tooltip title="Sync">
              <div>
                <IconButton
                  id="SyncButton"
                  onClick={(e) => {
                    e.preventDefault();
                    refetch();
                  }}
                >
                  <RefreshIcon />
                </IconButton>
              </div>
            </Tooltip>
          )}
          <DefaultThresholdFilter />
          <Tooltip title="View Devices">
            <div>
              <IconButton
                onClick={() => {
                  navigate(`${PAGES.DEVICE_MGMT}${location.search}`);
                }}
              >
                <Devices />
              </IconButton>
            </div>
          </Tooltip>
        </>
      )}
    />
  );
};
export default DefaultThresholdToolbar;
